import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import settingLink from "./setting-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import {  isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import Switch from "react-switch"
import SettingSidebar from "../../components/VerticalLayout/SettingSidebar";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap"
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";

import * as Yup from "yup";
import RsAdNewV2 from "components/buttons/Adnew-v2";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import axios from "axios";
import { API_URL } from "helpers/app_url";
import SaveButton from "components/buttons/save";
import RsLink from "components/buttons/rsLink";
import Swal from "sweetalert2";
import PhoneInputField from "components/dropdowns/PhoneInputField";
import SafeField from "helpers/SafeField";

class Users extends Component {
  constructor(props) {
    super(props)
    this.state = {
         
    }
        this.toggleAddNew = this.toggleAddNew.bind(this);
        this.toggleEditUser = this.toggleEditUser.bind(this);
  }

    addToggle() {
      this.setState(prevState => ({
        isAddNew: !prevState.isAddNew
      }));
    }
    toggleAddNew() {
      this.setState({ isAddNew: !this.state.isAddNew });
  
    }
  toggle() {
      this.setState(prevState => ({
          isManage: !prevState.isManage
      }));
  }
   toggleEditUser() {
      this.setState({ user: "", isEdit: false, isManage: !this.state.isManage});
      this.toggle();
    }
   toggleEditUser = arg => {
      const user = arg;
  
      this.setState({
        user: {
              id: user.id,
              agentId: user.agentId,
             

              primaryEmail: user.primaryEmail,
              firstName: user.firstName,
              lastName: user.lastName,
              agentTypeId: user.agentTypeId,
              addressId:user.addressId,
              contactId:user.contactId,
              userPermissionRole:user.userPermissionRole,
              department:user.department,
              createdBy: user.createdBy,
              phone: user.agentAssistantContact?.cContact?.phone,
              email: user.agentAssistantContact?.cContact?.email,
              mobile:  user.agentAssistantContact?.cContact?.mobile,
              isActive: user.isActive,

              agentCode: user.agentCode,
              organizationName: user.organizationName,
              logoFilePath: user.logoFilePath,
              agentImageFilePath: user.agentImageFilePath,
              logoContent: user.logoContent,
              agentStatusId: user.agentStatusId,
              isSingleRealtor: user.isSingleRealtor,
              agentNo: user.agentNo,
              agentPackage: user.agentPackage,
              twilioSMSNumber: user.twilioSMSNumber,
              notes: user.notes
        }
      })
      this.toggle();
   }
   componentDidMount() {
      this.fetchUser();
      this.fetchRoles();
   }
   handleSubmit = (value) => {
    
    const payload = {
      primaryEmail: value.email,
      firstName: value.firstName,
      lastName: value.lastName,
      agentTypeId: parseInt(value.userPermissionRole),
      addressId:0,
      contactId:0,
      userPermissionRole:parseInt(value.userPermissionRole),
      department:value.department,
      createdBy: parseInt(value.agentId),
      phone: value.mobile,
      email: value.email,
      mobile: value.mobile,
      isActive: true,
    };
  
    const token = JSON.parse(localStorage.getItem("authUser"))?.resultData?.bearerToken;
    if (!token) {
      toast.error("Unauthorized: No token found");
      return;
    }
  
    toast.loading("Please wait...");
  
    axios.post(`${API_URL}AgentAssistantExt`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
    .then(({ data }) => {
      toast.dismiss();
  
      if (data.success) {
        toast.success("Saved successfully!");
        this.fetchUser();
        this.toggleAddNew();
      } else {
        toast.error(data?.validationErrors?.[0] || "Submission failed");
        console.warn("Submission failed:", data);
      }
    })
    .catch((error) => {
      toast.dismiss();
      console.error("Error submitting document:", error);
      toast.error("Something went wrong!");
    });
  };
  
      fetchUser() {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };
    
        const params = {
          agentId: localStorage.getItem('userId')
        };
        axios
          .get(`${API_URL}AgentAssistantExt/allforagent`, { headers, params })
          .then((response) => {
            this.setState({ users: response.data, loading: false });
          })
          .catch((error) => {
            this.setState({ error: error.message, loading: false });
          });
      }
        handleDeleteUser = (user) => {
          Swal.fire({
            title: "Are you sure?",
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
          }).then((result) => {
            if (result.isConfirmed) {
              const obj = JSON.parse(localStorage.getItem("authUser"));
              const token = obj?.resultData?.bearerToken;
              axios
                .delete(`${API_URL}AgentAssistantExt/${user.id}`, {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                  },
                })
                .then((response) => {
                  Swal.fire("Deleted!", "Delete successfully", "success");
                  this.setState((prevState) => ({
                    users: prevState.users.filter((d) => d.id !== user.id),
                  }));
                })
                .catch((error) => {
                  Swal.fire("Error!", "An error occurred while deleting the document.", "error");
                });
            }
          });
        }
  
// handleUpdateSubmit = (value) => {
    
  
//     const payload = {
//       id: parseInt(value.id),
//       agentId: value.agentId,
//       primaryEmail: value.email,
//       firstName: value.firstName,
//       lastName: value.lastName,
//       agentTypeId: parseInt(value.userPermissionRole),
//       addressId:parseInt(value.addressId),
//       contactId:parseInt(value.contactId),
//       userPermissionRole:parseInt(value.userPermissionRole),
//       department:value.department,
//       createdBy: parseInt(value.createdBy),
//       phone: value.mobile,
//       email: value.email,
//       mobile: value.mobile,
//       isActive: true,

//       agentCode: value.agentCode,
//       organizationName: value.organizationName,
//       logoFilePath: value.logoFilePath,
//       agentImageFilePath: value.agentImageFilePath,
//       logoContent:value.logoContent,
//       agentStatusId:parseInt(value.agentStatusId),
//       isSingleRealtor:parseInt(value.isSingleRealtor),
//       agentNo: value.agentNo,
//       agentPackage: value.agentPackage,
//       twilioSMSNumber: value.twilioSMSNumber,
//       notes: value.notes
//     };
  
//     const token = JSON.parse(localStorage.getItem("authUser"))?.resultData?.bearerToken;
//     if (!token) {
//       toast.error("Unauthorized: No token found");
//       return;
//     }
  
//     toast.loading("Please wait...");
  
//     axios.put(`${API_URL}AgentAssistantExt`, payload, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "application/json",
//       },
//     })
//     .then(({ data }) => {
//       toast.dismiss();
  
//       if (data.success) {
//         toast.success("Updated successfully!");
//         this.fetchUser();
//       this.toggleEditUser();
//       } else {
//         toast.error(data?.validationErrors?.[0] || "Submission failed");
//         console.warn("Submission failed:", data);
//       }
//     })
//     .catch((error) => {
//       toast.dismiss();
//       console.error("Error submitting document:", error);
//       //toast.error(error?.response?.data?.message || "Something went wrong!");
//     })
//   .finally(() => {
//     toast.dismiss(); 
//   });
//   };
  
handleUpdateSubmit = async (value) => {
  toast.loading("Please wait...");
  const payload = {
    id: Number(value.id),
    agentId: value.agentId,
    primaryEmail: value.email,
    firstName: value.firstName,
    lastName: value.lastName,
    agentTypeId: Number(value.userPermissionRole),
    addressId: Number(value.addressId),
    contactId: Number(value.contactId),
    userPermissionRole: Number(value.userPermissionRole),
    department: value.department,
    createdBy: Number(value.createdBy),
    phone: value.mobile,
    email: value.email,      
    mobile: value.mobile,
    isActive: true,
    agentCode: value.agentCode,
    organizationName: value.organizationName,
    logoFilePath: value.logoFilePath,
    agentImageFilePath: value.agentImageFilePath,
    logoContent: value.logoContent,
    agentStatusId: Number(value.agentStatusId),
    isSingleRealtor: Number(value.isSingleRealtor),
    agentNo: value.agentNo,
    agentPackage: value.agentPackage,
    twilioSMSNumber: value.twilioSMSNumber,
    notes: value.notes
  };

  const token = JSON.parse(localStorage.getItem("authUser"))?.resultData?.bearerToken;
  if (!token) {
    toast.error("Unauthorized: No token found");
    return;
  }

  

  try {
    const response = await axios.put(`${API_URL}AgentAssistantExt`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (response.data.success) {
      toast.dismiss();
      toast.success("Updated successfully!");
      this.fetchUser();
      this.toggle();
    } else {
      toast.dismiss();
      toast.error(response?.data?.validationErrors?.[0] || "Submission failed");
    }
  } catch (error) {
    //  toast.dismiss();
    // this.fetchUser();
    // this.toggle();
  }
 
};

fetchRoles() {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
  
      const params = {
        agentId: localStorage.getItem('userId')
      };
      axios
        .get(`${API_URL}UserRole/allAgent`, { headers, params })
        .then((response) => {
          this.setState({ userroles: response.data, loading: false });
        })
        .catch((error) => {
          this.setState({ error: error.message, loading: false });
        });
    } 
render() {
  const { users, userroles, user } = this.state;
    return (
      <React.Fragment>
        <ToastContainer autoClose={2000} />
        <div className="page-content">
          <MetaTags>
            <title>Agent Profile | Realty Space</title>
          </MetaTags>
          <Container fluid>
          
       
           <Row className="">
            <Col xl="6">
             <Breadcrumbs
              title={this.props.t("Agent")}
              breadcrumbItem={this.props.t("Users")}
            />
           
            </Col>
            <Col sm="6">
             <div className="pt-2 mt-2 d-flex justify-content-center justify-content-xl-end flex-wrap">
                              <RsAdNewV2 to="#" onClick={this.toggleAddNew} iconClass="bx bx-right-arrow-alt" className="text-purple border-right">
                                  Add user
                              </RsAdNewV2>

                               <RsAdNewV2 to="/setting/manage-role" className="text-purple" iconClass="bx bx-plus-medical">Manage roles</RsAdNewV2>{" "}
              </div>
           
            </Col>
            </Row>
            <Row className="mt-4">
              <Col xl="3">
              <SettingSidebar />
              </Col>
              
              <Col xl="9">
              <Formik
                  enableReinitialize={true}
                  initialValues={{
                   
                   

                  }}
                  validationSchema={Yup.object().shape({
                   
                   
                  })}

                  onSubmit={values => {
                  
                   
                  }}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
            

            
                <Card> 
                    <CardBody>
                    
					<div className="table-responsive">
          <table className="table table-bordered border-primary align-middle table-nowrap mb-0">
              <thead className="">
							  <tr>
							
								<th>Name</th>
								
             
                <th>Role</th>
                <th>Email</th>
                 <th>Phone</th>
                  <th>Action</th>
                
                
							  </tr>
							</thead>
                    <tbody>
                        {users?.map((user, i) => (
                      <tr key={i}>
                        <td>{user.firstName + " " + user.lastName}</td>
                       
                        <td>{userroles?.find(role => role.id === user.userPermissionRole)?.userRoleTitle || ""}</td>
                       
                        <td>{user.primaryEmail}</td>
                        <td>{user.agentAssistantContact?.cContact?.mobile}</td>
                        <td>
                        
                            <ActionEdit onClick={()=> this.toggleEditUser(user)} />
                            <ActionDelete onClick={()=> this.handleDeleteUser(user)}  />
                        </td>
                      </tr>
                        ))}
                     
                    </tbody>
						  </table>
						</div>
					</CardBody>
					</Card>

                
                


               

            

</Form>
)}
</Formik>


 
            
            </Col>
            
            </Row>
           
          </Container>
        </div>
        <Offcanvas
                                isOpen={this.state.isAddNew}
                                direction="end"
                                toggle={this.toggleAddNew}
                                style={{ width: 800 }}
                              >
                                <OffcanvasHeader toggle={this.toggleAddNew}>
                                  New User
                                </OffcanvasHeader>
                                <OffcanvasBody>
                                   <Formik
                                        enableReinitialize={true}
                                        initialValues={{
                                        
                                           department: "",
                                           firstName:"",
                                           lastName:"",
                                           email:"",
                                           mobile:"",
                                           userPermissionRole:"",
                                           agentId : localStorage.getItem('userId')
        
                                        }}
                                        validationSchema={Yup.object().shape({
                                               department: Yup.string().required("This Field in required"),
                                               firstName: Yup.string().required("This Field in required"),
                                               lastName: Yup.string().required("This Field in required"),
                                               email: Yup.string().email('Invalid email').required('This Field in required'),
                                               mobile: Yup.string().required("This Field in required"),
                                               userPermissionRole:Yup.string().required("This Field in required"),
                                        })}
        
                                        onSubmit={this.handleSubmit}
                                        >
                                        {({ errors, touched, values, handleChange, setFieldValue }) => (
                                            <Form
                                            className="needs-validation"
                                            >
                                             <Row>
                                              <Col sm="4">
                                                       <FormGroup className="mb-3">
                                                        <Label htmlFor="department">
                                                        {this.props.t("Department *")}
                                                        </Label>
                                                        <SafeField
                                                        name="department"
                                                        type="text"
                                                        onChange={handleChange}
                                                        className={
                                                            "form-control" +
                                                            (errors.department && touched.department
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="department"
                                                        />
                                                        <ErrorMessage
                                                        name="department"
                                                        component="div"
                                                        className="invalid-feedback"
                                                        />
                                                    </FormGroup>
                                                 </Col> 
                                                  <Col sm="4">
                                                       <FormGroup className="mb-3">
                                                        <Label htmlFor="firstName">
                                                        {this.props.t("First Name *")}
                                                        </Label>
                                                        <SafeField
                                                        name="firstName"
                                                        type="text"
                                                        onChange={handleChange}
                                                        className={
                                                            "form-control" +
                                                            (errors.firstName && touched.firstName
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="firstName"
                                                        />
                                                        <ErrorMessage
                                                        name="firstName"
                                                        component="div"
                                                        className="invalid-feedback"
                                                        />
                                                    </FormGroup>
                                                 </Col>   
                                                   <Col sm="4">
                                                       <FormGroup className="mb-3">
                                                        <Label htmlFor="lastName">
                                                        {this.props.t("Last Name *")}
                                                        </Label>
                                                        <SafeField
                                                        name="lastName"
                                                        type="text"
                                                        onChange={handleChange}
                                                        className={
                                                            "form-control" +
                                                            (errors.lastName && touched.lastName
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="lastName"
                                                        />
                                                        <ErrorMessage
                                                        name="lastName"
                                                        component="div"
                                                        className="invalid-feedback"
                                                        />
                                                    </FormGroup>
                                                 </Col>  
                                                   <Col sm="4">
                                                       <FormGroup className="mb-3">
                                                        <Label htmlFor="email">
                                                        {this.props.t("Email *")}
                                                        </Label>
                                                        <SafeField
                                                        name="email"
                                                        type="text"
                                                        onChange={handleChange}
                                                        className={
                                                            "form-control" +
                                                            (errors.email && touched.email
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="email"
                                                        />
                                                        <ErrorMessage
                                                        name="email"
                                                        component="div"
                                                        className="invalid-feedback"
                                                        />
                                                    </FormGroup>
                                                 </Col>
                                                   <Col sm="4">
                                                      <PhoneInputField
                                                        label="Mobile"
                                                        name="mobile"
                                                        value={values.mobile}
                                                        setFieldValue={setFieldValue}
                                                        error={errors.mobile}
                                                        touched={touched.mobile}
                                                        country="ca"
                                                        required={true}
                                                      />
                                                 </Col> 
                                                   <Col sm="4">
                                                       <FormGroup className="mb-3">
                                                        <Label htmlFor="userPermissionRole">
                                                        {this.props.t("Select role *")}
                                                        </Label>
                                                         <SafeField as="select" name="userPermissionRole"
                                                          className={
                                                            "form-control" +
                                                            (errors.userPermissionRole && touched.userPermissionRole
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                         >
                                                                  <option value="">Select</option>
                                                                  {userroles.map((option) => (
                                                                    <option key={option.id} value={option.id}>
                                                                      {option.userRoleTitle}
                                                                    </option>
                                                                  ))}
                                                                </SafeField>
                                                        <ErrorMessage
                                                        name="userPermissionRole"
                                                        component="div"
                                                        className="invalid-feedback"
                                                        />
                                                    </FormGroup>
                                                 </Col>        
                                                     <div><SaveButton>{this.props.t("Save")}</SaveButton>{ " " } <RsLink onClick={this.toggleAddNew}>Close</RsLink></div>
                                            </Row>           
                                            </Form>
                                        )}
                                        </Formik>
                                </OffcanvasBody>
                              </Offcanvas>
        
        
                                  <Offcanvas
                                isOpen={this.state.isManage}
                                direction="end"
                                toggle={this.toggleEditUser}
                                style={{ width: 800 }}
                              >
                                <OffcanvasHeader toggle={this.toggleEditUser}>
                                  Update Role
                                </OffcanvasHeader>
                                <OffcanvasBody>
                                  <Formik
                                        enableReinitialize={true}
                                        initialValues={{
                                        
                                          id: user?.id,
                                          agentId: user?.agentId,
                                          primaryEmail: user?.primaryEmail,
                                          firstName: user?.firstName,
                                          lastName: user?.lastName,
                                          agentTypeId: user?.agentTypeId,
                                          addressId:user?.addressId,
                                          contactId:user?.contactId,
                                          userPermissionRole:user?.userPermissionRole,
                                          department:user?.department,
                                          createdBy: user?.createdBy,
                                          phone: user?.phone,
                                          email: user?.email,
                                          mobile:  user?.mobile,
                                          isActive: user?.isActive,

                                          agentCode: user?.agentCode,
                                          organizationName: user?.organizationName,
                                          logoFilePath: user?.logoFilePath,
                                          agentImageFilePath: user?.agentImageFilePath,
                                          logoContent: user?.logoContent,
                                          agentStatusId: user?.agentStatusId,
                                          isSingleRealtor: user?.isSingleRealtor,
                                          agentNo: user?.agentNo,
                                          agentPackage: user?.agentPackage,
                                          twilioSMSNumber: user?.twilioSMSNumber,
                                          notes: user?.notes
        
                                        }}
                                        validationSchema={Yup.object().shape({
                                               department: Yup.string().required("This Field in required"),
                                               firstName: Yup.string().required("This Field in required"),
                                               lastName: Yup.string().required("This Field in required"),
                                               email: Yup.string().email('Invalid email').required('This Field in required'),
                                               mobile: Yup.string().required("This Field in required"),
                                               userPermissionRole:Yup.string().required("This Field in required"),
                                        })}
        
                                        onSubmit={this.handleUpdateSubmit}
                                        >
                                        {({ errors, touched, values, handleChange, setFieldValue }) => (
                                            <Form
                                            className="needs-validation"
                                            >
                                             <Row>
                                              <Col sm="4">
                                                       <FormGroup className="mb-3">
                                                        <Label htmlFor="department">
                                                        {this.props.t("Department *")}
                                                        </Label>
                                                        <SafeField
                                                        name="department"
                                                        type="text"
                                                        onChange={handleChange}
                                                        className={
                                                            "form-control" +
                                                            (errors.department && touched.department
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="department"
                                                        />
                                                        <ErrorMessage
                                                        name="department"
                                                        component="div"
                                                        className="invalid-feedback"
                                                        />
                                                    </FormGroup>
                                                 </Col> 
                                                  <Col sm="4">
                                                       <FormGroup className="mb-3">
                                                        <Label htmlFor="firstName">
                                                        {this.props.t("First Name *")}
                                                        </Label>
                                                        <SafeField
                                                        name="firstName"
                                                        type="text"
                                                        onChange={handleChange}
                                                        className={
                                                            "form-control" +
                                                            (errors.firstName && touched.firstName
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="firstName"
                                                        />
                                                        <ErrorMessage
                                                        name="firstName"
                                                        component="div"
                                                        className="invalid-feedback"
                                                        />
                                                    </FormGroup>
                                                 </Col>   
                                                   <Col sm="4">
                                                       <FormGroup className="mb-3">
                                                        <Label htmlFor="lastName">
                                                        {this.props.t("Last Name *")}
                                                        </Label>
                                                        <SafeField
                                                        name="lastName"
                                                        type="text"
                                                        onChange={handleChange}
                                                        className={
                                                            "form-control" +
                                                            (errors.lastName && touched.lastName
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="lastName"
                                                        />
                                                        <ErrorMessage
                                                        name="lastName"
                                                        component="div"
                                                        className="invalid-feedback"
                                                        />
                                                    </FormGroup>
                                                 </Col>  
                                                   <Col sm="4">
                                                       <FormGroup className="mb-3">
                                                        <Label htmlFor="email">
                                                        {this.props.t("Email *")}
                                                        </Label>
                                                        <SafeField
                                                        name="email"
                                                        type="text"
                                                        onChange={handleChange}
                                                        className={
                                                            "form-control" +
                                                            (errors.email && touched.email
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="email"
                                                        />
                                                        <ErrorMessage
                                                        name="email"
                                                        component="div"
                                                        className="invalid-feedback"
                                                        />
                                                    </FormGroup>
                                                 </Col>
                                                   <Col sm="4">
                                                      <PhoneInputField
                                                        label="Mobile"
                                                        name="mobile"
                                                        value={values.mobile}
                                                        setFieldValue={setFieldValue}
                                                        error={errors.mobile}
                                                        touched={touched.mobile}
                                                        country="ca"
                                                        required={true}
                                                      />
                                                 </Col> 
                                                   <Col sm="4">
                                                       <FormGroup className="mb-3">
                                                        <Label htmlFor="userPermissionRole">
                                                        {this.props.t("Select role *")}
                                                        </Label>
                                                         <SafeField as="select" name="userPermissionRole"
                                                          className={
                                                            "form-control" +
                                                            (errors.userPermissionRole && touched.userPermissionRole
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                         >
                                                                  <option value="">Select</option>
                                                                  {userroles.map((option) => (
                                                                    <option key={option.id} value={option.id}>
                                                                      {option.userRoleTitle}
                                                                    </option>
                                                                  ))}
                                                                </SafeField>
                                                        <ErrorMessage
                                                        name="userPermissionRole"
                                                        component="div"
                                                        className="invalid-feedback"
                                                        />
                                                    </FormGroup>
                                                 </Col>        
                                                     <div><SaveButton>{this.props.t("Update")}</SaveButton>{ " " } <RsLink onClick={this.toggleEditUser}>Close</RsLink></div>
                                            </Row>           
                                            </Form>
                                        )}
                                        </Formik>
                                </OffcanvasBody>
                              </Offcanvas>
      </React.Fragment>
    )
  }
}
Users.propTypes = {
  t: PropTypes.any,
  history:PropTypes.object,
  match: PropTypes.object,
 

}
const mapStateToProps = () => (
  {
    
    

  })
const mapDispatchToProps = dispatch => ({
  

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Users))
